module.exports = __webpack_public_path__ + "static/media/Group 86.5b4baede.png";